// extracted by mini-css-extract-plugin
export var columnList = "_cb-0";